<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.name == "CollaboratorBets") {
      this.mainTab();
    }
  },

  watch: {
    $route(val) {
      if (val.name == "CollaboratorBets") {
        this.mainTab();
      }
    },
  },

  computed: {
    canBetsReport() {
      return this.$permission("1");
    },
    canListBets() {
      return this.$permission("2");
    },
  },

  methods: {
    mainTab() {
      let name = "";

      if (this.canBetsReport) {
        name = "CollaboratorChartOnline";
      } else if (this.canListBets) {
        name = "CollaboratorBetListPlayerOnline";
      }

      this.$router.push({ name });
    },
  },
};
</script>
